import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RegistroPersonasEmpresasLibModule } from '@rpe/registro-personas-empresas-lib';
import { SharedModule } from '../../shared/shared.module';
import { DocumentoPersonaFormComponent } from './documentos-persona/documento-persona-form/documento-persona-form.component';
import { EntityPersonaFormContainerComponent } from './entity-personas/components/entity-persona-form-container/entity-persona-form-container.component';
import { PersonaFormComponent } from './entity-personas/components/persona-form/persona-form.component';
import { PersonasEffects } from './entity-personas/entity-personas.effects';
import { UbicacionesModule } from '../ubicaciones/ubicaciones.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TerminosCondicionesComponent } from '../terminos-condiciones/terminos-condiciones.component';
import { TerminoCondicionesDialogComponent } from '../termino-condiciones-dialog/termino-condiciones-dialog.component';
import { RouterModule } from '@angular/router';
import { ContactosModule } from '../contactos/contactos.module';

@NgModule({
  declarations: [
    DocumentoPersonaFormComponent,
    EntityPersonaFormContainerComponent,
    PersonaFormComponent,
    TerminosCondicionesComponent,
    TerminoCondicionesDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    SharedModule,
    UbicacionesModule,
    RouterModule,
    RegistroPersonasEmpresasLibModule,
    ContactosModule,
    EffectsModule.forFeature([PersonasEffects])
  ],
  exports: [
    DocumentoPersonaFormComponent,
    EntityPersonaFormContainerComponent,
    PersonaFormComponent,
    TerminosCondicionesComponent,
    TerminoCondicionesDialogComponent
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }]
})
export class PersonaModule {}
